const actionTypes = {
    MERGE_PAGE_DATA: 'MERGE_PAGE_DATA',
    SET_PAGE_DATA: 'SET_PAGE_DATA',
    SHOW_SPA_PAGE_LOAD_PROGRESS: 'SHOW_SPA_PAGE_LOAD_PROGRESS'
};

module.exports = actionTypes;
